import React, { useEffect, useState } from "react";
import "../CardfordownloadEditViewAction/CardfordownloadEditViewAction.css";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { fonts, themes } from "../../themes/themes";
import { useAppSelector } from "../../../infra/hooks";
import { check_user_permission } from "../../configs/utils";

interface contentTileType {
  tile_value: string;
  subtitle1: string;
  PolicyNo: any;
  Issuetitle: string;
  IssueDate: any;
  ExpDate: any;
  Expirytitle: string;
  subtitle2: string;
  amount: any;
  onEdit?: any;
  onDelete?: any;

  onView?: any;
}
const CardforInsuranceList: React.FC<contentTileType> = ({
  tile_value,
  subtitle1,
  PolicyNo,
  Issuetitle,
  IssueDate,
  Expirytitle,
  ExpDate,
  subtitle2,
  amount,
  onDelete,
  onEdit,

  onView,
}) => {
  const auth_permissions = useAppSelector((state:any) => state.authPermissionSlice?.authPermission);
  return (
    <Grid container className="action-tileContainer">
      <Grid item xs={9}>
        <Typography
          className="title1"
          sx={{ fontSize: "0.95em", fontWeight: "bold" }}
        >
          {tile_value}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: "0.75em" }}>
              {subtitle1} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: "0.75em",
                fontWeight: "bold",
              }}
            >
              {PolicyNo}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: "0.75em" }}>
              {subtitle2}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: "0.75em",
                fontWeight: "bold",
                marginLeft: "0.2em",
              }}
            >
              {amount}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: "100%",
          }}
        >
          <Grid item style={{ marginTop: "0.09em" }}>
            <Typography className="Issuetitle" sx={{ fontSize: "0.75em" }}>
              {Issuetitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="IssueDate"
              sx={{
                fontSize: "0.875em",
                marginLeft: "0.2em",
                fontWeight: "bold",
              }}
            >
              {`${IssueDate} `}
            </Typography>
          </Grid>

          <Grid item style={{ marginTop: "0.1em" }}>
            <Typography
              className="Issuetitle"
              sx={{
                fontSize: "0.75em",
              }}
            >
              {Expirytitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="IssueDate"
              sx={{
                fontSize: "0.875em",
                marginLeft: "0.2em",
                fontWeight: "bold",
              }}
            >
              {ExpDate}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={3}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
       { check_user_permission(auth_permissions,true,"edit") ?(<> <Grid item>
          <Box
            style={{
              border: "1px solid #E6E8EF",
              color: "#21D8A5",
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onEdit}
          >
            <i className="las la-pencil-alt"></i>
          </Box>
        </Grid>
        <Grid item>
          <Box
            style={{
              border: "1px solid #E6E8EF",
              color: "#FF5263",
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onDelete}
          >
            <i className="las la-trash-alt"></i>
          </Box>
        </Grid>
        </> ):<></>}
        <Grid item>
          <Box
            style={{
              border: "1px solid #E6E8EF",
              color: "#7C0E6F",
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onView}
          >
            <i className="lar la-eye"></i>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default CardforInsuranceList;
